const SOUND_SOURCES = ['/show.wav', '/timer.mp3', '/correct.wav', '/wrong.wav'];
const sounds = new Map();
let isUnlocked = false;

const getSound = (src) => {
  if (typeof window === 'undefined') return null;
  if (!sounds.has(src)) {
    const audio = new Audio(src);
    audio.preload = 'auto';
    sounds.set(src, audio);
  }
  return sounds.get(src);
};

export const unlockSounds = () => {
  if (isUnlocked || typeof window === 'undefined') return;
  isUnlocked = true;

  SOUND_SOURCES.forEach((src) => {
    getSound(src)?.load();
  });
};

export const playSound = (src, { loop = false } = {}) => {
  const audio = getSound(src);
  if (!audio) return null;

  audio.loop = loop;
  audio.muted = false;
  audio.currentTime = 0;
  audio.play().catch(e => console.log('Audio blocked:', e));
  return audio;
};

export const stopSound = (audio) => {
  if (!audio) return;
  audio.pause();
  audio.currentTime = 0;
  audio.loop = false;
};
